export default "__VITE_ASSET__CEBvPNiJ__"